"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.list.title': 'Pasos de Onboarding',
    'step.list.empty': 'No se encontraron pasos',
};
